"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const homeSlice_1 = require("../../features/home/homeSlice");
const icon_1 = require("../icon/icon");
const appMessagesStyles_1 = __importDefault(require("./appMessagesStyles"));
const styles_1 = __importDefault(require("../../styles/styles"));
const appMessageLayout_1 = __importDefault(require("./appMessageLayout"));
const store_1 = require("../../store");
const AppMessages = ({ children, isHomeContainer }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const appMessages = (0, store_1.useAppSelector)((state) => state.home.appMessages);
    const showMessage = appMessages && appMessages.messages && appMessages.display;
    let clear = () => { };
    let message = null;
    if (showMessage) {
        [message] = appMessages.messages;
        clear = () => {
            dispatch((0, homeSlice_1.hideMessage)());
            if (message && message.actionButton) {
                message.actionButton();
            }
        };
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.View, { style: showMessage ? styles_1.default.noDisplay : [styles_1.default.flexOne] },
            react_1.default.createElement(react_native_1.View, { style: isHomeContainer ? appMessagesStyles_1.default.mainHomeContainer : appMessagesStyles_1.default.mainContainer }, children)),
        react_1.default.createElement(react_native_1.View, { style: showMessage ? [styles_1.default.flexOne] : styles_1.default.noDisplay }, message ? (react_1.default.createElement(appMessageLayout_1.default, { hasLogo: message.hasLogo, icon: message.iconType || icon_1.APPMESSAGE_CHECK_CIRCLE, textTitle: message.title, textSubtitle: message.message, buttonTextPrimary: message.buttonText, onPressPrimary: clear, eventNamePrimary: "exit_app_message", showButton: message.showButton })) : null)));
};
exports.default = AppMessages;
